export default __webpack_public_path__ + "static/media/hj1.8ee0b1c3.jpg";